module.exports = __webpack_public_path__ + "media/images/google-icon-a2de267c.svg";